import type { AssetId, ProjectId, TimeStreamAsset } from 'owa-timestream-types';
import { deleteAssets, getMultipleAssets, setAnnouncement } from 'owa-timestream-store';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import {
    announceItemRemoved,
    announceItemsRemoved,
    deleteConfirmationTitle,
    deleteConfirmationSingleText,
    deleteConfirmationMultipleText,
    removeButtonText,
} from './deleteAssetsWithConfirm.locstring.json';
import loc from 'owa-localize';

export default async function deleteAssetsWithConfirm(
    projectId: ProjectId,
    selectedAssets: AssetId[]
): Promise<boolean> {
    if (!selectedAssets.length) {
        return false;
    }

    let shouldDelete = true;
    let singleItem = selectedAssets.length == 1;

    const assets: (TimeStreamAsset | null)[] = getMultipleAssets(projectId, selectedAssets);

    const containsBucket = assets.some(asset => asset?.type === 'bucket');
    if (containsBucket) {
        const assetsCount = assets.reduce((val, asset) => val + (asset?.children?.length ?? 0), 0);
        if (assetsCount > 0) {
            singleItem = false;
            const response = await confirm(
                loc(deleteConfirmationTitle),
                assetsCount == 1
                    ? loc(deleteConfirmationSingleText)
                    : loc(deleteConfirmationMultipleText, assetsCount),
                false,
                {
                    okText: loc(removeButtonText),
                    delayCallbackAfterAnimation: true,
                }
            );

            shouldDelete = response === DialogResponse.ok;
        }
    }

    if (shouldDelete) {
        deleteAssets(projectId, selectedAssets);
        setAnnouncement(loc(singleItem ? announceItemRemoved : announceItemsRemoved));
    }

    return shouldDelete;
}
